// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selected: null,
  capacitation: null,
  current:null
}

const drives = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_DATA':
      return { ...state, allData: action.data }
    case 'GET_DRIVES':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'ADD_DOCUMENT':
      return { ...state }
    case 'DELETE_DOCUMENT':
      return { ...state }
    case 'GET_DRIVE':
      return { ...state, current: action.current }
    case 'GET_CAPACITATION_DETAIL':
      return { ...state, capacitation: action.capacitation }
    case 'EDIT_DOCUMENT':
      return { ...state }
    default:
      return { ...state }
  }
}
export default drives
